Vue.component('seasonal', {
    template: templates.adminSeason,
    data() {
      return {
        model: {
            edit: false,
            season: {
                name: null,
                description: null,
                startDate: null,
                startTime: null,
                endSeason: null,
                active: false,
            },
            seasons: {},
            seasonStarted: false
        }
      }
    },
    mounted() {
        const c = this;
        c.get();
        
        c.$root.$on('seasonStartEnd', data => {
        console.log(data)
        c.model.seasonStarted =! data
  
        setTimeout(function(){
          c.get();
        },500)
        c.reset();
        utils.alert.success('Saved!');
        })
    },
    methods: {
     get(){
        const c = this;
        let data = {};

        console.log('triggered')
        seasonService.get()
        .then(function (response) {
    
        for (let d of response.data) {
            if(d.endSeason){
              c.model.seasonStarted = true;
            }
            d.image = `${root}/images/seasonal/${d.id}.png`;
            d.video = `/videos/seasonal/${d.id}.webm`;
            data[`${d.id}`] = d;
        }
 
        c.model.seasons = data;
        })
        .catch(function (error) {
          console.log(error);
        });
        console.log(c.model)
     },
     handleClick(){
        const c = this;

        // c.model.edit = true;

        if(!c.model.seasonStarted){
          let data = {
            message: 'Are you sure you want to start a new season?',
            season: c.model.season,
            status: true,
            isPaused: null
          }
          $('.modal').addClass('is-above').addClass('is-visible');
          c.$root.$emit('startEndSeason', data);
        }
        else{

          let data = {
            message: 'Are you sure you want to end the season?',
            season: c.model.season,
            status: false,
            isPaused: null
          }
          $('.modal').addClass('is-above').addClass('is-visible');
          c.$root.$emit('startEndSeason', data);
      
        }
     },
     edit(id){
        const c = this;
        let data = c.model.seasons[`${id}`];

        if (id == c.model.season.id) {
            c.model.edit = false;
        } else {
            c.model.edit = true;
        }

        console.log(data.active)
        
        c.model.season = {
            id: id,
            startDate: data.startDate,
            endDate: data.endDate,
            active: data.active,
        }
     },
     reset() {
        const c = this;
        c.model.edit = false;

        c.model.season = {
            startDate: null,
            endDate: null,
        }
     },
     save(startSeason){
        const c = this;
        let data = c.model.season;
        data.status = startSeason;

        seasonService.save(data)
          .then(function (response) {
            c.get();
  
            c.reset();
            
            utils.alert.success('Saved!');
            
          })
          .catch(function (error) {
            utils.alert.error('Failed to save.');
          });

          console.log(c.model)

     },
     pause(isPaused){

      const c = this;
      let data = c.model.season;
      data.isPaused = isPaused;

      if(!data.isPaused){
        let data = {
          message: 'resume current season?',
          season: c.model.season,
          status: true,
          isPaused: isPaused
        }
        $('.modal').addClass('is-above').addClass('is-visible');
        c.$root.$emit('startEndSeason', data);
      }
      else{

        let data = {
          message: 'Are you sure you want to pause the current season?',
          season: c.model.season,
          status: false,
          isPaused: isPaused
        }
        $('.modal').addClass('is-above').addClass('is-visible');
        c.$root.$emit('startEndSeason', data);
    
      }

      // seasonService.save(data)
      //   .then(function (response) {

      //     c.get();

      //     c.reset();
          
      //     utils.alert.success('Saved!');
          
      //   })
      //   .catch(function (error) {
      //     utils.alert.error('Failed to save.');
      //   });
     },
     upload() {
        const c = this;
  
        let data = new FormData();
        data.append('file', this.$refs.file.files[0]);
        data.append('type', 'seasonal');
        data.append('id', c.model.season.id);
  
        uploadService.uploadFile(data)
          .then(function (response) {
            utils.alert.success('File uploaded!');
          })
          .catch(function (error) {
            utils.alert.error('File failed to uploaded.');
          });
      },
    }
  });

  
    